import React from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import FormGroup from '../../../FormGroup';

const Helper = ({ t }) => {
    const renderTitle = () => {
        let staticNames = t?.paymentPage?.settingModal || {};

        return (
            <FormGroup>
                <h3>{staticNames.requisites}</h3>
            </FormGroup>
        );
    };

    return renderTitle();
};

Helper.propTypes = {
    t: PropTypes.object
};

Helper.defaultProps = {
    t: {}
};

export default withTranslation(Helper);
